/* eslint-disable @typescript-eslint/no-use-before-define */
import {
  ControlValueAccessor,
  FormControl,
  FormControlName,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import {
  Input,
  Component,
  forwardRef,
  HostListener,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ETextareaStyleType } from "../../../data-types/textarea-style.enum";
@Component({
  selector: "cowing-textarea",
  templateUrl: "./cowing-textarea.component.html",
  styleUrls: ["./cowing-textarea.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CowingTextareaComponent),
      multi: true,
    },
  ],
})
export class CowingTextareaComponent implements ControlValueAccessor {
  @HostListener("document:click", ["$event"])
  onClick(event) {}

  @Input("value") value: string;
  @Input("rows") rows = 6;
  @Input("maxLength") maxLength = 800;
  @Input("textareaStyle") textareaStyle: string = ETextareaStyleType.Primary;
  @Input("label") label: string = "";
  @Input("placeholder") placeholder: string = "";
  @Input("required") required: boolean = false;
  @Input("isForm") isForm: boolean = false;
  @Input("control") control: FormControl = null;

  @ViewChild("textarea") textarea: ElementRef;
  keyboard: any;
  toggledShowPassword = false;
  valid = false;
  checked: boolean;
  msg = "";
  status = "";

  private internalTextareaChange;
  constructor() {}

  writeValue(value: any): void {
    if (value) {
      this.value = value;
    }
  }
  registerOnChange(fn: any): void {
    this.internalTextareaChange = fn;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    // throw new Error("Method not implemented.");
  }
  onKeyPress(button) {
    console.log("Button pressed", button);
  }

  validateFormat() {
    if (this.required) {
      console.log("required", this.value);
      this.msg =
        this.value != "" && this.value != null
          ? ""
          : "common.validation.required";
      this.status = this.value != "" && this.value != null ? "" : "error";
      this.valid = this.value != "" && this.value != null ? true : false;
      this.checked = this.value != "" && this.value != null ? false : true;
    }
  }
}
